import React from 'react';
import './components.css';

export default function ContactContent() {
  return (
    <div>
      <h3 className='oswald mt-2'>contact me</h3>
      <p className='text-w200 m-0'>You can contact me at</p>
      <ul className='mt-1'>
        <li className='text-w200'>
          {' '}
          <a className='anchor-none' href='https://www.facebook.com/akulsr0'>
            facebook
          </a>
        </li>
        <li className='text-w200'>
          {' '}
          <a className='anchor-none' href='https://www.instagram.com/akulsr0/'>
            instagram
          </a>
        </li>
        <li className='text-w200'>
          {' '}
          <a className='anchor-none' href='https://twitter.com/akulsr0'>
            twitter
          </a>
        </li>
        <li className='text-w200'>
          {' '}
          <a
            className='anchor-none'
            href='https://www.linkedin.com/in/akulsr0/'
          >
            linkedin
          </a>
        </li>
        <li className='text-w200'>
          {' '}
          <a className='anchor-none' href='https://github.com/akulsr0'>
            github
          </a>
        </li>
        <li className='text-w200'>
          {' '}
          <p className='text-w200' style={{ color: '#585858' }}>
            mail: akulsr0@gmail.com
          </p>
        </li>
      </ul>
    </div>
  );
}
